<script setup lang="ts">
// 接受父组件传递的参数
interface Prors {
  icon?: string
  img?: string
}
withDefaults(defineProps<Prors>(), {
  icon: 'i-local:trx',
  img: 'https://static.tronscan.org/production/logo/trx.png',
})
</script>

<template>
  <div class="bg-[--bg-one] text-white rounded-[10px] p-[15px] flex items-center lt-mobilel:px-[15px] lt-mobilel:py-[10px] lt-mobilel:text-xs">
    <i v-if="icon" class="icon text-[20px] overflow-hidden rounded-[5px] mr-[10px]" :class="icon" />
    <img v-else class="w-20px h-20px mr-[10px] lt-mobilel:(mr-8px]" :src="img">
    <p><slot>地址</slot></p>
  </div>
</template>
